module.exports = __webpack_public_path__ + "img/f13.c81443ee.jpg";